import React from 'react'
import Numbers from "website/home/how-it-works-numbers.svg"

const HowItWorks = () => (
  <div className="how-it-works-container">
    <div className='how-it-works-left-side'>
      <h3 className="mb-4">How it works</h3>
      <p>
        You can start your application online by clicking 
        <a href='/onboarding_funnel/new'> apply now</a> or 
        <span onClick={() => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false;}}> booking a call </span>
          with one of our loan consultants at a time that suits you
      </p>
      <div className='how-it-works-btn-container'>
        <a className="btn btn-xl btn-green mr-sm-2 apply-now-btn" id="apply-now-btn" href='/onboarding_funnel/new'>
          Apply now
        </a>
        <span 
          className="btn btn-xl btn-line-green ml-sm-2 view-rates-btn" 
          onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
          id="view-rates-btn">
          Talk to an expert
        </span>
      </div>
    </div>
    <div className="how-it-works-right-side">
      <Numbers />
      <div className='text-container'>
        <div className='text'>Start your application</div>
        <div className='text supporting-doc'>Provide your supporting documentation</div>
        <div className='text assess-your-app'>We assess your application</div>
        <div className='text'>Sign your loan documents</div>
        <div className='text we-settle'>We settle your loan</div>
      </div>

    </div>
      <div className='how-it-works-btn-container-mobile'>
        <a className="btn btn-xl btn-green mr-sm-2 apply-now-btn" id="apply-now-btn" href='/onboarding_funnel/new'>
          Apply now
        </a>
        <span 
          className="btn btn-xl btn-line-green ml-sm-2 view-rates-btn" 
          onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
          id="view-rates-btn">
          Talk to an expert
        </span>
      </div>
  </div>
);

export default HowItWorks
